import React from 'react';
import '../App.css';
import { Icon } from 'semantic-ui-react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { storageUtils } from '../utils/localStorage';
import {
  GROUPS,
  GROUP_CHILI_IDS,
  GROUP_LABELS,
  isGroup,
} from '../utils/groups';

export default function Settings() {
  const history = useHistory();
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState('');
  const [completedItems, setCompletedItems] = useState([]);
  const [assignedGroup, setAssignedGroup] = useState('');

  useEffect(() => {
    // Load user data
    const user = storageUtils.getUser();
    const name = storageUtils.getUserName();
    const items = storageUtils.getCompletedItems();
    const group = storageUtils.getGroup();

    if (user) setUserEmail(user);
    if (name) setUserName(name);
    setCompletedItems(items);
    if (isGroup(group)) setAssignedGroup(group);
  }, []);

  const handleLogout = () => {
    // Clear all user data
    storageUtils.clearUser();

    // Redirect to home page
    window.location.href = '/';
  };

  const clearVotingData = () => {
    if (
      window.confirm(
        'Are you sure you want to clear all your voting data? This cannot be undone.'
      )
    ) {
      storageUtils.clearCompletedItems();
      setCompletedItems([]);
    }
  };

  const completedInGroup = (group) =>
    (GROUP_CHILI_IDS[group] || []).filter((id) =>
      completedItems.includes(id)
    ).length;

  const assignedGroupIsComplete =
    isGroup(assignedGroup) &&
    completedInGroup(assignedGroup) === GROUP_CHILI_IDS[assignedGroup].length;

  const groupsWithChilisRemaining = GROUPS.filter(
    (group) =>
      group !== assignedGroup &&
      completedInGroup(group) < GROUP_CHILI_IDS[group].length
  );

  const tasteMoreChilis = (group) => {
    storageUtils.addAdditionalGroup(group);
    storageUtils.setActiveGroup(group);
    history.push(`/${group}`);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background:
          'linear-gradient(139deg, rgba(175, 255, 139, 1) 0%, rgba(255, 191, 130, 1) 45%, rgba(255, 124, 123, 1) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        padding: '20px',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '30px',
          padding: '40px',
          textAlign: 'center',
          maxWidth: '500px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: '30px' }}>
          <div
            style={{
              width: '80px',
              height: '80px',
              backgroundColor: 'white',
              borderRadius: '40px',
              margin: '0 auto 20px auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Icon
              name="setting"
              size="big"
              style={{ color: 'rgb(250, 107, 5)' }}
            />
          </div>
          <h1
            style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#2c2c2c',
              margin: '0 0 8px 0',
            }}
          >
            Settings
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#666',
              margin: 0,
            }}
          >
            Manage your account and voting data
          </p>
        </div>

        {/* User Info Section */}
        {(userEmail || userName) && (
          <div
            style={{
              backgroundColor: '#f8f9fa',
              borderRadius: '16px',
              padding: '20px',
              marginBottom: '30px',
              textAlign: 'left',
            }}
          >
            <h3
              style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#2c2c2c',
                margin: '0 0 12px 0',
              }}
            >
              Account Information
            </h3>
            {userName && (
              <p
                style={{
                  fontSize: '14px',
                  color: '#666',
                  margin: '0 0 8px 0',
                }}
              >
                <strong>Name:</strong> {userName}
              </p>
            )}
            {userEmail && (
              <p
                style={{
                  fontSize: '14px',
                  color: '#666',
                  margin: '0 0 8px 0',
                }}
              >
                <strong>Email:</strong> {userEmail}
              </p>
            )}
            {isGroup(assignedGroup) && (
              <p
                style={{
                  fontSize: '14px',
                  color: '#666',
                  margin: '0 0 8px 0',
                }}
              >
                <strong>Assigned Group:</strong>{' '}
                {GROUP_LABELS[assignedGroup]}
              </p>
            )}
            <p
              style={{
                fontSize: '14px',
                color: '#666',
                margin: 0,
              }}
            >
              <strong>Votes Cast:</strong> {completedItems.length} chili
              {completedItems.length !== 1 ? 's' : ''}
            </p>
          </div>
        )}

        {isGroup(assignedGroup) && (
          <section
            aria-labelledby="taste-more-title"
            style={{
              backgroundColor: '#fff7ed',
              border: '1px solid #fed7aa',
              borderRadius: '16px',
              padding: '20px',
              marginBottom: '30px',
            }}
          >
            <h2
              id="taste-more-title"
              style={{
                fontSize: '20px',
                fontWeight: '700',
                color: '#2c2c2c',
                margin: '0 0 8px 0',
              }}
            >
              {assignedGroupIsComplete
                ? 'Ready for more?'
                : 'Want to try more chilis?'}
            </h2>
            <p
              style={{
                fontSize: '15px',
                lineHeight: '1.5',
                color: '#666',
                margin: '0 0 18px 0',
              }}
            >
              {assignedGroupIsComplete
                ? `You finished your ${GROUP_LABELS[assignedGroup]} group. Choose another group to keep tasting.`
                : `Finish your ${GROUP_LABELS[assignedGroup]} group to unlock more chilis.`}
            </p>

            {!assignedGroupIsComplete ? (
              <div>
                <div
                  role="progressbar"
                  aria-label={`${GROUP_LABELS[assignedGroup]} group progress`}
                  aria-valuemin="0"
                  aria-valuemax={GROUP_CHILI_IDS[assignedGroup].length}
                  aria-valuenow={completedInGroup(assignedGroup)}
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    height: '10px',
                    margin: '0 auto 8px',
                    overflow: 'hidden',
                    borderRadius: '999px',
                    backgroundColor: '#fed7aa',
                  }}
                >
                  <div
                    style={{
                      width: `${
                        (completedInGroup(assignedGroup) /
                          GROUP_CHILI_IDS[assignedGroup].length) *
                        100
                      }%`,
                      height: '100%',
                      borderRadius: 'inherit',
                      backgroundColor: 'rgb(250, 107, 5)',
                      transition: 'width 0.2s ease',
                    }}
                  />
                </div>
                <p
                  style={{
                    margin: '0 0 16px',
                    fontSize: '14px',
                    color: '#666',
                  }}
                >
                  {completedInGroup(assignedGroup)} of{' '}
                  {GROUP_CHILI_IDS[assignedGroup].length} rated
                </p>
                <button
                  type="button"
                  disabled
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    minHeight: '48px',
                    border: '1px solid #d1d5db',
                    borderRadius: '12px',
                    padding: '10px 18px',
                    backgroundColor: '#f5f5f5',
                    color: '#777',
                    fontSize: '15px',
                    fontWeight: '600',
                    cursor: 'not-allowed',
                  }}
                >
                  Finish your group to unlock
                </button>
              </div>
            ) : groupsWithChilisRemaining.length > 0 ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                {groupsWithChilisRemaining.map((group) => (
                  <button
                    key={group}
                    type="button"
                    onClick={() => tasteMoreChilis(group)}
                    style={{
                      width: '100%',
                      maxWidth: '300px',
                      minHeight: '48px',
                      border: '2px solid rgb(250, 107, 5)',
                      borderRadius: '12px',
                      padding: '10px 18px',
                      backgroundColor: 'white',
                      color: 'rgb(200, 76, 0)',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Taste {GROUP_LABELS[group]} chilis
                    <span
                      style={{
                        display: 'block',
                        marginTop: '2px',
                        fontSize: '12px',
                        fontWeight: '400',
                        color: '#666',
                      }}
                    >
                      {completedInGroup(group)} of{' '}
                      {GROUP_CHILI_IDS[group].length} rated
                    </span>
                  </button>
                ))}
              </div>
            ) : (
              <p style={{ margin: 0, color: '#444', fontWeight: '600' }}>
                You've rated every chili. Thank you!
              </p>
            )}
          </section>
        )}

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          {/* Clear Voting Data Button */}
          {completedItems.length > 0 && (
            <button
              onClick={clearVotingData}
              style={{
                backgroundColor: 'transparent',
                color: '#dc3545',
                border: '2px solid #dc3545',
                borderRadius: '12px',
                padding: '14px 30px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                minWidth: '250px',
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#dc3545';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#dc3545';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              🗑️ Clear Voting Data
            </button>
          )}

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: 'rgb(250, 107, 5)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 32px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(250, 107, 5, 0.3)',
              minWidth: '250px',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'rgb(230, 90, 0)';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(250, 107, 5, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgb(250, 107, 5)';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(250, 107, 5, 0.3)';
            }}
          >
            🚪 Log Out
          </button>

          {/* Back to Home Button */}
          <Link
            to="/"
            style={{ textDecoration: 'none', width: '100%', maxWidth: '250px' }}
          >
            <button
              style={{
                backgroundColor: 'transparent',
                color: 'rgb(250, 107, 5)',
                border: '2px solid rgb(250, 107, 5)',
                borderRadius: '12px',
                padding: '14px 30px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                width: '100%',
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = 'rgb(250, 107, 5)';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'rgb(250, 107, 5)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              🏠 Back to Home
            </button>
          </Link>
        </div>

        {/* Footer */}
        <p
          style={{
            fontSize: '12px',
            color: '#999',
            marginTop: '30px',
            fontStyle: 'italic',
          }}
        >
          JJ's Chili Cookoff {storageUtils.getCurrentYear()} 🌶️
        </p>
      </div>
    </div>
  );
}
